import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink,
  Nav,
  Button,
  NavbarToggler,
  Collapse,
} from "reactstrap";
import { logout } from "../../helper-methods";

const DashboardHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const _logout = () => {
    logout(navigate);
  };
  // menu
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  // menu
  const _isActiveTab = (route) => {
    return location?.pathname === route ? true : false;
  };

  return (
    <Navbar expand="md" className="projectHeader" light>
      <NavbarBrand onClick={() => navigate("/")} className="order-1">
        <img src={require("../../assets/img/company-logo.png")} alt="Logo" />
      </NavbarBrand>
      <div className="order-2 order-md-3">
        <NavbarToggler onClick={toggle} />

        <Button onClick={() => _logout()} color="link" className="text-danger">
          <i className="fas fa-power-off" />
        </Button>
      </div>
      <Collapse className="order-md-2 order-3" isOpen={isOpen} navbar>
        <Nav className="m-auto" navbar>
          <NavItem>
            <NavLink
              className={_isActiveTab("/groups") ? "active" : ""}
              onClick={() => navigate("/groups")}
            >
              Groups
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={_isActiveTab("/members") ? "active" : ""}
              onClick={() => navigate("/members")}
            >
              Members
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={_isActiveTab("/swaps") ? "active" : ""}
              onClick={() => navigate("/swaps")}
            >
              Swaps
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={_isActiveTab("/team-member") ? "active" : ""}
              onClick={() => navigate("/team-member")}
            >
              Team
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={_isActiveTab("/moderation") ? "active" : ""}
              onClick={() => navigate("/moderation")}
            >
              Moderation
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={_isActiveTab("/monitoring") ? "active" : ""}
              onClick={() => navigate("/monitoring")}
            >
              Monitoring
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={_isActiveTab("/reports") ? "active" : ""}
              onClick={() => navigate("/reports")}
            >
              Reports
            </NavLink>
          </NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default DashboardHeader;
